module.exports = __webpack_public_path__ + "img/ilustracion-404.ccfa238a.svg";